<template>
  <div class="page-wrap">
    <div class="page-inner-wrap">
      <iframe :src="iframeLink" class="iframe"></iframe>
    </div>
    <nav-bar></nav-bar>
  </div>
</template>
<script setup lang="ts">
import {
  reactive,
  ref,
  onActivated,
  computed,
  watch,
  onDeactivated,
} from "vue";
import { addUrlParams } from "@utiles/index";
import NavBar from "@components/common/NavBar.vue";
import useCharInfo from "@hooks/useCharInfo";
import { useRoute, useRouter } from "vue-router";
import { useBaseStore } from "@store/base";
import useModule from "@hooks/useModule";
import useLoading from "@hooks/useLoading";
import usePointViewPage from "@hooks/usePointViewPage";
import { goLogin } from "@api/base";
const { setLoadingState } = useLoading();
console.log("EmbedIframe init");
const props = defineProps({
  iframeUrl: {
    default: "",
  },
});

const { roleId, serverId, roleName, loginAccount } = useCharInfo();

const route = useRoute();
const router = useRouter();

const base = useBaseStore();

const iframeLink = computed(() => {
  return addUrlParams(
    {
      siteName: base.name,
      language: base.lang,
      gameId: base.gameId,
      serverId: serverId.value,
      roleId: roleId.value,
      roleName: roleName.value,
      loginAccount: loginAccount.value,
      loginName: loginAccount.value,
      sid: "",
      scid: "",
    },
    props.iframeUrl
  );
});

window.addEventListener(
  "message",
  function ({ data }) {
    if (data && data.action === "goLogin") {
      goLogin(base.gameId);
      return;
    }
  },
  false
);
</script>

<style lang="scss" scoped>
@import "@assets/scss/dimen.scss";

.page-wrap {
  overflow-x: hidden;
  height: 100%;
  padding-bottom: 0;

  .page-inner-wrap {
    padding: 0;
    height: 100%;

    .iframe {
      width: 100%;
      height: 100%;
    }
  }
}

@media only screen and (min-height: 640px) and (orientation: landscape) {
  .page-wrap {
  }
}
</style>
